// TODO: Move all the prompts here
export const PROMPTS = {
  teachingGuide: 'lpCerebroTeachingGuide',
};

export const DEFAULT_SEARCH_PROMPT =
  'Find reliable information from reputable sources for a detailed explanation that is easy to understand';
